import _implicitStylesheets from "./analyticsInstrument.css";
import _implicitScopedStylesheets from "./analyticsInstrument.scoped.css?scoped=true";
import {freezeTemplate, registerTemplate} from "lwc";
const stc0 = [];
function tmpl($api, $cmp, $slotset, $ctx) {
  const {b: api_bind, s: api_slot} = $api;
  const {_m0} = $ctx;
  return [api_slot("", {
    key: 0,
    on: {
      "slotchange": _m0 || ($ctx._m0 = api_bind($cmp.handleSlotChange))
    }
  }, stc0, $slotset)];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.slots = [""];
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-3d7t8v97p58";
tmpl.legacyStylesheetToken = "undefined-_analyticsInstrument";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
